export const SET_THEME_COLOR = "SET_THEME_COLOR";
export const SET_GRADIENT_COLOR = "SET_GRADIENT_COLOR";
export const SETCANCELCHEQUE = "SETCANCELCHEQUE";
export const SETBANKSTATEMENT = "SETBANKSTATEMENT";
export const SETEXCHANGESEGMENT = "SETEXCHANGESEGMENT";
export const SETNOMINEEPROOFVALIDATE = "SETNOMINEEPROOFVALIDATE";
export const REACTIVATION_PROOF = "REACTIVATION_PROOF";
export const ACCOUNTCLOSURESCREEN = "ACCOUNTCLOSURESCREEN";

